import React from "react";
import AboutImg from "../components/images/abraham.png";

const Main = () => {
  return (
    <main className="w-full" id="Main">
      <div className="max-w-6xl h-[100%] text-white mx-auto flex items-center max-lg:flex-col-reverse justify-between text-gray-400 px-4">
        <section
          className="lg:mt-[5rem] md:w-1/2 w-full max-lg:text-center max-md:px-2"
          data-aos="fade-right"
          data-aos-duration="1100"
        >
          <span className="text-[1.4rem] max-sm:text-[1rem]">
            Hey! <span>&#128075;</span> dear , welcome
          </span>
          <h2 className="text-[3rem] max-sm:text-[2rem]">I AM COVENANT</h2>
          <p className="lg:pr-4 max-lg:px-4">
            a fullstack developer aspiring and rapidly gasping in knowledge
            necessary for solution provision, let me get you a site.
          </p>
          <br />
          <a
            href="mailto: abrahamcovenant2004@gmail.com"
            className="bg-blue-700 py-1 px-5 text-white rounded-sm border-none font-[300]"
          >
            HIRE ME
          </a>
        </section>
        <section
          className="mt-[9rem] max-lg:mt-[6rem] md:w-1/2 w-full flex lg:justify-end justify-center py-2"
          data-aos="fade-up"
          data-aos-duration="1100"
        >
          <img src={AboutImg} alt="" className="h-[18rem] lg:h-[25rem] rounded-t-full bg-[rgba(0,0,0,0.5)]" />
        </section>
      </div>
    </main>
  );
};

export default Main;
